"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _reactKonva = require("react-konva");

var _reactBootstrap = require("react-bootstrap");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _moment = _interopRequireDefault(require("moment"));

var _QuestionsActions = require("../../redux/Questions/QuestionsActions");

var _config = require("../../config/config");

var _Question = _interopRequireDefault(require("../Question/Question"));

var _SelectedActions = require("../../redux/SelectedQuestion/SelectedActions");

var _excluded = ["id"],
    _excluded2 = ["id"],
    _excluded3 = ["id"];
/* eslint-disable react/forbid-prop-types */

/* eslint-disable no-underscore-dangle */

function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
      t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}

function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };

  var t = _getRequireWildcardCache(r);

  if (t && t.has(e)) return t.get(e);
  var n = {
    __proto__: null
  },
      a = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var u in e) {
    if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
      var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
      i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
  }

  return n["default"] = e, t && t.set(e, n), n;
}

var Canvas = function Canvas(_ref) {
  var img = _ref.img,
      pageNumber = _ref.pageNumber,
      formData = _ref.formData,
      questionSet = _ref.questionSet,
      selectedQuestion = _ref.selectedQuestion,
      latestAddedQuestion = _ref.latestAddedQuestion,
      apiUpdateQuestion = _ref.apiUpdateQuestion,
      nonApiAddQuestion = _ref.nonApiAddQuestion,
      setCurrentlySelectedQuestion = _ref.setCurrentlySelectedQuestion,
      deselectQuestion = _ref.deselectQuestion,
      removeQuestion = _ref.removeQuestion,
      updateSelectedQuestion = _ref.updateSelectedQuestion;
  var stageRef = (0, _react.useRef)();
  var stageDivRef = (0, _react.useRef)();

  var _useState = (0, _react.useState)(951),
      stageWidth = _useState[0],
      setStageWidth = _useState[1];

  var _useState2 = (0, _react.useState)(1231),
      stageHeight = _useState2[0],
      setStageHeight = _useState2[1];

  var stageStyle = {
    backgroundImage: "url(" + img + ")",
    backgroundSize: '100%',
    backgroundRepeat: 'no-repeat'
  };
  var _window$pdfFormConfig = window.pdfFormConfigObject.field_types,
      textField = _window$pdfFormConfig.text_field,
      decimalField = _window$pdfFormConfig.decimal_field,
      selectField = _window$pdfFormConfig.select_field,
      dateField = _window$pdfFormConfig.date_field,
      signatureField = _window$pdfFormConfig.signature_field,
      radioField = _window$pdfFormConfig.radio_field,
      checkboxField = _window$pdfFormConfig.checkbox_field,
      _window$pdfFormConfig2 = _window$pdfFormConfig.multi_checkbox_field,
      multiCheckboxField = _window$pdfFormConfig2 === void 0 ? 27 : _window$pdfFormConfig2;
  var _window$pdfFormConfig3 = window.pdfFormConfigObject,
      questionOwner = _window$pdfFormConfig3.questionOwner,
      questionOwnerType = _window$pdfFormConfig3.questionOwnerType; // If this flag is true, we're in Onboarding and can use multi_checkbox; if not, we need to use checkbox

  var multiCheckboxEnabled = window.pdfFormConfigObject.enableMultiCheckbox !== false;

  _moment["default"].locale('en', {
    longDateFormat: {
      LLL: 'h:mma on M/D'
    }
  });

  var handleOnDrop = function handleOnDrop(e) {
    e.preventDefault(); // register event position

    stageRef.current.setPointersPositions(e);
    var elementType = e.dataTransfer.getData('type');
    var questionPosition = {
      pos: [100 * (stageRef.current.getPointerPosition().x / stageWidth), 100 * (stageRef.current.getPointerPosition().y / stageHeight), ['checkbox', 'radio'].includes(elementType) ? _config.ANSWER_WIDTH : _config.QUESTION_WIDTH, ['checkbox', 'radio'].includes(elementType) ? _config.ANSWER_HEIGHT : _config.QUESTION_HEIGHT],
      page: pageNumber,
      size: 12,
      character_spacing: '0',
      align: 'left',
      overflow: 'shrink_to_fit'
    };
    var answerPosition = {
      pos: [100 * (stageRef.current.getPointerPosition().x / stageWidth), 100 * (stageRef.current.getPointerPosition().y / stageHeight), _config.ANSWER_WIDTH, _config.ANSWER_HEIGHT]
    };

    switch (elementType) {
      case 'additional-checkbox':
        {
          var newAnswersAttributes = selectedQuestion.answers_attributes.map(function (answer) {
            return answer;
          });
          newAnswersAttributes.push({
            name: 'Type Here',
            position: selectedQuestion.answers_attributes.length + 1,
            data: answerPosition
          });
          var updatedAnswersAttributesQuestion = (0, _extends2["default"])({}, selectedQuestion, {
            answers_attributes: newAnswersAttributes
          });
          apiUpdateQuestion(updatedAnswersAttributesQuestion);
          break;
        }

      case 'text-field':
        nonApiAddQuestion({
          data: questionPosition,
          name: 'New Text Field',
          owner_id: questionOwner,
          owner_type: questionOwnerType,
          question_type: textField,
          position: questionSet.length + 1
        });
        break;

      case 'number':
        nonApiAddQuestion({
          question_type: decimalField,
          data: questionPosition,
          name: 'New Number Field',
          owner_id: questionOwner,
          owner_type: questionOwnerType,
          position: questionSet.length + 1
        });
        break;

      case 'date':
        nonApiAddQuestion({
          data: questionPosition,
          name: 'New Date Field',
          owner_id: questionOwner,
          owner_type: questionOwnerType,
          question_type: dateField,
          position: questionSet.length + 1
        });
        break;

      case 'dropdown':
        nonApiAddQuestion({
          data: questionPosition,
          name: 'New Dropdown Field',
          owner_id: questionOwner,
          owner_type: questionOwnerType,
          question_type: selectField,
          answers_attributes: [{
            name: '__answer_name__'
          }, {
            name: '__answer_name__'
          }],
          position: questionSet.length + 1
        });
        break;

      case 'signature':
        nonApiAddQuestion({
          data: questionPosition,
          name: 'New Signature Field',
          owner_id: questionOwner,
          owner_type: questionOwnerType,
          question_type: signatureField,
          position: questionSet.length + 1
        });
        break;

      case 'checkbox':
        nonApiAddQuestion({
          data: questionPosition,
          name: 'New Checkbox Field',
          owner_id: questionOwner,
          owner_type: questionOwnerType,
          question_type: multiCheckboxEnabled ? multiCheckboxField : checkboxField,
          answers_attributes: multiCheckboxEnabled ? [{
            name: 'Option 1',
            position: 1,
            data: {
              pos: [questionPosition.pos[0], questionPosition.pos[1] + 5, questionPosition.pos[2], questionPosition.pos[3]],
              page: questionPosition.page,
              size: questionPosition.size || 12,
              character_spacing: '0',
              align: 'left',
              overflow: 'shrink_to_fit'
            }
          }] : []
        });
        break;

      case 'radio':
        nonApiAddQuestion({
          data: questionPosition,
          name: 'New Radio Field',
          owner_id: questionOwner,
          owner_type: questionOwnerType,
          question_type: radioField,
          answers_attributes: [{
            name: 'Option 1',
            position: 1,
            data: {
              pos: [questionPosition.pos[0], questionPosition.pos[1] + 5, questionPosition.pos[2], questionPosition.pos[3]],
              page: questionPosition.page,
              size: questionPosition.size || 12,
              character_spacing: '0',
              align: 'left',
              overflow: 'shrink_to_fit'
            }
          }]
        });
        break;

      default:
        break;
    }
  };

  var checkSize = function checkSize() {
    var width = stageDivRef.current.offsetWidth;
    var adjustedHeight = width * (stageHeight / stageWidth);

    if (width !== 0) {
      setStageWidth(width);
      setStageHeight(adjustedHeight);
    }
  };

  (0, _react.useEffect)(function () {
    checkSize();
    window.addEventListener('resize', checkSize);
    return function () {
      return window.removeEventListener('resize', checkSize);
    };
  }, []);
  (0, _react.useEffect)(function () {
    setCurrentlySelectedQuestion(latestAddedQuestion, null);
  }, [latestAddedQuestion]);

  var setSelectedQuestionRedux = function setSelectedQuestionRedux(newSelectedQuestion, selectedAnswer) {
    setCurrentlySelectedQuestion(newSelectedQuestion, selectedAnswer);
  };

  var checkDeselect = function checkDeselect(e) {
    var clickedOnEmptyArea = e.target === e.target.getStage();

    if (clickedOnEmptyArea) {
      deselectQuestion();
    }
  };

  var onKeyPressed = function onKeyPressed(e) {
    if (e.key === 'Backspace' && selectedQuestion) {
      deselectQuestion();
      removeQuestion(selectedQuestion);
    }
  };

  var changeQuestionFromPage = function changeQuestionFromPage(increasePage, questionSize) {
    var page = increasePage ? selectedQuestion.data.page + 1 : selectedQuestion.data.page - 1;
    var position = increasePage ? 5 : 95 - questionSize; // let newYPosition = 5;

    var newData = {
      pos: [selectedQuestion.data.pos[0], position, selectedQuestion.data.pos[2], selectedQuestion.data.pos[3]],
      page: page
    };
    var questionCopy = (0, _extends2["default"])({}, selectedQuestion, {
      answers: selectedQuestion.answers.map(function (answer) {
        var id = answer.id,
            answerWithoutID = (0, _objectWithoutPropertiesLoose2["default"])(answer, _excluded);
        var newAnswer = (0, _extends2["default"])({}, answerWithoutID, {
          data: {
            pos: [answerWithoutID.data.pos[0], position, answerWithoutID.data.pos[2], answerWithoutID.data.pos[3]]
          }
        });
        return newAnswer;
      }),
      answers_attributes: selectedQuestion.answers_attributes.map(function (answer) {
        var id = answer.id,
            answerWithoutID = (0, _objectWithoutPropertiesLoose2["default"])(answer, _excluded2);
        var newAnswer = (0, _extends2["default"])({}, answerWithoutID, {
          data: {
            pos: [answerWithoutID.data.pos[0], position, answerWithoutID.data.pos[2], answerWithoutID.data.pos[3]]
          }
        });
        return newAnswer;
      })
    });
    var id = questionCopy.id,
        questionWithoutID = (0, _objectWithoutPropertiesLoose2["default"])(questionCopy, _excluded3);
    nonApiAddQuestion((0, _extends2["default"])({}, questionWithoutID, {
      data: newData
    }));
  };

  var fieldIsNotMultiCheckboxOrRadio = function fieldIsNotMultiCheckboxOrRadio(questionType) {
    return questionType !== radioField && questionType !== multiCheckboxField;
  };

  return (
    /*#__PURE__*/
    _react["default"].createElement(_reactBootstrap.Container, {
      ref: stageDivRef,
      className: "p-0 mt-2",
      "data-cy": "viewer" + pageNumber,
      id: "page-" + pageNumber,
      onDrop: handleOnDrop,
      onDragOver: function onDragOver(e) {
        return e.preventDefault();
      },
      "data-testid": "viewer"
    },
    /*#__PURE__*/
    _react["default"].createElement("div", {
      tabIndex: -1,
      onKeyDown: onKeyPressed,
      "aria-hidden": "true",
      "data-testid": "stagediv",
      role: "presentation"
    },
    /*#__PURE__*/
    _react["default"].createElement(_reactKonva.Stage, {
      style: stageStyle,
      width: stageWidth,
      height: stageHeight,
      ref: stageRef,
      onMouseDown: checkDeselect,
      "data-cy": "stage",
      "data-testid": "stage",
      className: "shadow mb-1 bg-white"
    }, questionSet ?
    /*#__PURE__*/
    _react["default"].createElement(_reactKonva.Layer, {
      "data-testid": "layer"
    }, questionSet.map(function (image) {
      return image.data.page === pageNumber && fieldIsNotMultiCheckboxOrRadio(image.question_type) &&
      /*#__PURE__*/
      _react["default"].createElement(_Question["default"], {
        key: image.id,
        image: image,
        draggable: true,
        pagesLimit: formData.pages,
        shapeProps: image,
        stageWidth: stageWidth,
        stageHeight: stageHeight,
        isSelected: image.id === (selectedQuestion ? selectedQuestion.id : null),
        onChangePage: function onChangePage(increasePage, questionSize) {
          changeQuestionFromPage(increasePage, questionSize);
          deselectQuestion();
          removeQuestion(selectedQuestion);
        },
        onChange: function onChange(newAttrs) {
          updateSelectedQuestion(newAttrs);
        },
        onSelect: function onSelect() {
          setSelectedQuestionRedux(image, null);
        }
      });
    })) :
    /*#__PURE__*/
    _react["default"].createElement(_reactKonva.Layer, null), questionSet &&
    /*#__PURE__*/
    _react["default"].createElement(_reactKonva.Layer, null, questionSet.map(function (image) {
      // For checkbox and radio fields, display the answers
      if (image.data.page === pageNumber && !fieldIsNotMultiCheckboxOrRadio(image.question_type)) {
        return (image.answers_attributes || []).filter(function (answer) {
          return !answer._destroy;
        }).map(function (answer, i) {
          // Ensure the answer has all required properties
          var answerData = answer.data || {};
          var answerPage = answerData.page || image.data.page;
          var answerPos = answerData.pos || image.data.pos;
          return (
            /*#__PURE__*/
            _react["default"].createElement(_Question["default"], {
              key: answer.id || "new-" + i,
              question: image,
              image: (0, _extends2["default"])({}, answer, {
                data: (0, _extends2["default"])({}, answerData, {
                  page: answerPage,
                  pos: answerPos
                })
              }),
              draggable: true,
              pagesLimit: formData.pages,
              shapeProps: (0, _extends2["default"])({}, answer, {
                data: (0, _extends2["default"])({}, answerData, {
                  page: answerPage,
                  pos: answerPos
                })
              }),
              stageWidth: stageWidth,
              stageHeight: stageHeight,
              isSelected: image.id === (selectedQuestion ? selectedQuestion.id : null),
              onChangePage: function onChangePage(increasePage, questionSize) {
                changeQuestionFromPage(increasePage, questionSize);
                deselectQuestion();
                removeQuestion(selectedQuestion);
              },
              onSelect: function onSelect() {
                setCurrentlySelectedQuestion(image);
              },
              onChange: function onChange(newAttrs, question) {
                // holy inline functions batman!!
                var questionCopy = (0, _extends2["default"])({}, question); // Find the ID from either the direct answer, answers_attributes, or answers array

                var answerId = null;

                if (answer && answer.id) {
                  answerId = answer.id;
                } else if (questionCopy.answers_attributes && questionCopy.answers_attributes[i] && questionCopy.answers_attributes[i].id) {
                  answerId = questionCopy.answers_attributes[i].id;
                } else if (questionCopy.answers && questionCopy.answers[i] && questionCopy.answers[i].id) {
                  answerId = questionCopy.answers[i].id;
                }

                var updatedAnswer = (0, _extends2["default"])({}, answer, newAttrs); // Ensure we preserve the answer ID for proper updating

                if (answerId) {
                  updatedAnswer.id = answerId;
                }

                var updatedAnswers = [].concat(questionCopy.answers_attributes);
                updatedAnswers[i] = updatedAnswer;
                questionCopy.answers_attributes = updatedAnswers;
                updateSelectedQuestion(questionCopy);
              }
            })
          );
        });
      }

      return null;
    })))))
  );
};

Canvas.defaultProps = {
  formData: {},
  questionSet: [],
  selectedQuestion: null,
  latestAddedQuestion: null
};
Canvas.propTypes = process.env.NODE_ENV !== "production" ? {
  img: _propTypes["default"].string.isRequired,
  pageNumber: _propTypes["default"].number.isRequired,
  formData: _propTypes["default"].shape({
    pages: _propTypes["default"].number,
    thumbnails: _propTypes["default"].objectOf(_propTypes["default"].any)
  }),
  questionSet: _propTypes["default"].arrayOf(_propTypes["default"].any),
  selectedQuestion: _propTypes["default"].shape({
    id: _propTypes["default"].number,
    data: _propTypes["default"].shape({
      page: _propTypes["default"].number,
      pos: _propTypes["default"].arrayOf(_propTypes["default"].number)
    }),
    question_type: _propTypes["default"].number,
    answers_attributes: _propTypes["default"].arrayOf(_propTypes["default"].any),
    answers: _propTypes["default"].arrayOf(_propTypes["default"].any)
  }),
  latestAddedQuestion: _propTypes["default"].shape({
    id: _propTypes["default"].number,
    data: _propTypes["default"].shape({
      page: _propTypes["default"].number
    }),
    question_type: _propTypes["default"].number,
    answers_attributes: _propTypes["default"].arrayOf(_propTypes["default"].any)
  }),
  updateSelectedQuestion: _propTypes["default"].func.isRequired,
  apiUpdateQuestion: _propTypes["default"].func.isRequired,
  nonApiAddQuestion: _propTypes["default"].func.isRequired,
  setCurrentlySelectedQuestion: _propTypes["default"].func.isRequired,
  deselectQuestion: _propTypes["default"].func.isRequired,
  removeQuestion: _propTypes["default"].func.isRequired
} : {};

var mapStateToProps = function mapStateToProps(state) {
  return {
    formData: state.form.document,
    questionSet: state.questionSet.questions,
    selectedQuestion: state.selectedQuestion.selectedQuestion,
    latestAddedQuestion: state.questionSet.latestAddedQuestion
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    updateSelectedQuestion: function updateSelectedQuestion(question) {
      return dispatch((0, _QuestionsActions.updateQuestion)(question, (0, _moment["default"])().format('LLL')));
    },
    setCurrentlySelectedQuestion: function setCurrentlySelectedQuestion(question, selectedAnswer) {
      return dispatch((0, _SelectedActions.setSelectedQuestion)(question, selectedAnswer));
    },
    deselectQuestion: function deselectQuestion() {
      return dispatch((0, _SelectedActions.unselectQuestion)());
    },
    removeQuestion: function removeQuestion(question) {
      return dispatch((0, _QuestionsActions.deleteQuestion)(question, (0, _moment["default"])().format('LLL')));
    },
    apiUpdateQuestion: function apiUpdateQuestion(question) {
      return dispatch((0, _QuestionsActions.waitApiUpdateQuestion)(question, (0, _moment["default"])().format('LLL')));
    },
    nonApiAddQuestion: function nonApiAddQuestion(question) {
      return dispatch((0, _QuestionsActions.addQuestion)(question, (0, _moment["default"])().format('LLL')));
    }
  };
};

var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Canvas);